import { render, staticRenderFns } from "./TemplateModal.vue?vue&type=template&id=99eee8a0&scoped=true&"
import script from "./TemplateModal.vue?vue&type=script&lang=ts&"
export * from "./TemplateModal.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateModal.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./TemplateModal.vue?vue&type=style&index=1&id=99eee8a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99eee8a0",
  null
  
)

export default component.exports